<template>
  <div
    class="service_card_main"
    :class="[{'service-card-up': up },{'en-service-main': isEnglish}]"
  >
    <service-card
      v-if="!up"
    >
      <template v-slot:price>
        <h2
          class="price"
        >
          0
        </h2>
      </template>
      <template slot="list">
        <ul class="service_list">
          <li><li-icon /><span>{{ memberNumTip[0] }}</span>{{ memberNumTip[1] }}</li>
          <li><li-icon /><span>{{ eveyDayTip [0] }}</span>{{ eveyDayTip [1] }}</li>
          <li><li-icon /><span>{{ $t('message["1135"]') }}</span></li>
          <li><li-icon :opacity=".4" /><span>{{ $t('message["1258"]') }}</span></li>
          <li><li-icon :opacity=".4" /><span>{{ $t('message["1663"]') }}logo</span></li>
          <li><li-icon :opacity=".4" /><span>{{ $t('message["558"]') }}</span></li>
          <li><li-icon :opacity=".4" /><span>{{ $t('message["711"]') }}</span></li>
        </ul>
        <span class="s-i-btn s-i-cur-btn">{{ $t('message["157"]') }}</span>
      </template>
    </service-card>
    <service-card
      :title="advanceTit"
      :is-advanced="true"
    >
      <template v-slot:price>
        <h2 class="price">
          440
        </h2>
      </template>
      <!-- <template v-slot:header>
        <p class="service_unit_price">
          年付440元/人
        </p>
      </template> -->
      <template v-slot:list>
        <ul class="service_list">
          <li><li-icon /><span>{{ $t('message["1322"]') }}）</span></li>
          <li><li-icon /><span>{{ $t('message["630"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["1134"]') }}）</span></li>
          <li><li-icon /><span>{{ $t('message["1258"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["1663"]') }}logo</span></li>
          <li><li-icon /><span>{{ $t('message["558"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["711"]') }}</span></li>
        </ul>
        <template>
          <template v-if="up">
            <a
              v-if="!$isDingDing"
              href="javascript:;"
              class="s-i-btn s-i-advanced-btn"
              @click="upService"
            >
              {{ $t('message["599"]') }}
            </a>
            <ding-tip
              v-else
              type="upgrade"
            />
          </template>
          <a
            v-else
            href="javascript:;"
            class="s-i-btn s-i-advanced-btn"
            @click="openService"
          >
            {{ $t('message["602"]') }}
          </a>
        </template>
      </template>
    </service-card>
  </div>
</template>

<script type="text/ecmascript-6">
import liIcon from './SvgLi'
import ServiceCard from './ServiceCard'
import { mapActions } from 'vuex'
import { getLang } from '@/lib/storage'
import DingTip from '@/components/pc/serviceup/DingTip'

// const CRUMB_TITLE = '服务升级'
export default {
  components: {
    liIcon,
    ServiceCard,
    DingTip
  },
  props: {
    up: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     vm.setCrumbLabel(CRUMB_TITLE)
  //   })
  // },
  computed: {
    advanceTit () {
      return this.$t('message["351"]')
    },
    eveyDayTip () {
      return this.$t('message["629"]').split('|')
    },
    memberNumTip () {
      return this.$t('message["1321"]').split('|')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  methods: {
    ...mapActions('service', ['getServiceInfo']),
    getLang,
    async openService () {
      const chain = await this.getServiceInfo()
      chain.onSuccess(raw => {
        this.$emit('openService')
      })
        .fetch()
    },
    upService () {
      this.$emit('upService')
    }
  }
}
</script>

<style scoped lang="scss">
.service_card_main {
  display: flex;
  flex-direction: row
}
.service-card-up::v-deep {
  .card-item {
    margin: 0 auto;
  }
}
.en-service-main {
  height: auto !important;
  .service_list {
    width: 265px;
    position: static;
    margin: 35px auto 0;
    li {
      position: relative;
      padding-left: 24px;
      line-height: 22px;
      svg{
        position: absolute;
        left: 0;
        width: 16px;
        height: 16px;
        top: 4px;
      }
      span {
        margin-left: 0;
      }
    }
  }
  .s-i-btn {
    transform: translateX(0);
    margin: 30px auto 35px;
    position: static;
    display: block;
  }
}
</style>
